import ReactGA from 'react-ga';
import config from 'config';
import * as FullStory from '@fullstory/browser';

let userId = null;
let groupId = null;

export const initialize = ({ userId: _userId, groupId: _groupId }) => {
  userId = _userId;
  groupId = _groupId;

  ReactGA.initialize(config.googleAnalyticsCode, {
    debug: process.env.NODE_ENV !== 'production',
    gaOptions: {
      userId,
    },
  });

  ReactGA.set({
    dimension1: 'user_id',
    dimension2: 'utc_milliseconds',
    dimension3: 'group_id',
  });

  ReactGA.pageview(window.location.pathname + window.location.search);

  // Heap Analytics
  // see: https://developers.heap.io/docs/web
  if (config.heapAnalyticsCode) {
    window.heap = window.heap || [];
    window.heap.load = function (e, t) {
      window.heap.appid = e;
      // eslint-disable-next-line no-multi-assign
      window.heap.config = t = t || {};
      const r = document.createElement('script');
      r.type = 'text/javascript';
      r.async = !0;
      r.src = `https://cdn.heapanalytics.com/js/heap-${e}.js`;
      const a = document.getElementsByTagName('script')[0];
      a.parentNode.insertBefore(r, a);
      for (
        let n = function (e) {
            return function () {
              // eslint-disable-next-line prefer-rest-params
              window.heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
          },
          p = [
            'addEventProperties',
            'addUserProperties',
            'clearEventProperties',
            'identify',
            'resetIdentity',
            'removeEventProperty',
            'setEventProperties',
            'track',
            'unsetEventProperty',
          ],
          o = 0;
        o < p.length;
        o++
      )
        window.heap[p[o]] = n(p[o]);
    };

    window.heap.load(config.heapAnalyticsCode);
    window.heap.identify(userId);
    window.heap.addUserProperties({ groupId: groupId });
  }

  // FullStory
  if (config.fullStoryOrgId) {
    FullStory.init({ orgId: config.fullStoryOrgId });
    FullStory.identify(userId, { groupId_int: groupId });
  }
};

export const anonymize = () => {
  if (config.heapAnalyticsCode) {
    window.heap.resetIdentity();
  }

  if (config.fullStoryOrgId) {
    FullStory.anonymize();
  }
};

export const notifyPageView = value => {
  ReactGA.pageview(value);
};

export const notifyEvent = ({ action, category, label, value }) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value,
    dimension1: userId,
    dimension2: new Date().getTime().toString(),
    dimension3: `${groupId || ''}`,
  });
};
